import React from "react";

// Skeleton loader for an individual order item
function OrderItemSkeleton() {
  return (
    <div className="flex border-t pt-4  mt-4">
      <div className="mr-4">
        <div className="w-24 h-24 bg-gray-200 rounded animate-pulse"></div>
      </div>
      <div className="flex-1">
        <div className="h-5 bg-gray-200 rounded w-2/3 mb-4 animate-pulse"></div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-1/3 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-1/3 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}

// Skeleton loader for an entire order
function OrderSkeleton() {
  return (
    <div className="border rounded-lg p-4 mb-6 shadow-sm bg-white">
      <div className="flex justify-between mb-4">
        <div className="flex space-x-6">
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
          </div>
          <div className="space-y-2 mb-2">
            <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
        </div>
      </div>
      {/* <OrderItemSkeleton /> */}
      <OrderItemSkeleton />
    </div>
  );
}

// Main skeleton loader component for orders list
function OrdersSkeleton() {
  return (
    <div className="w-full max-w-4xl mx-auto">
      <OrderSkeleton />
      <OrderSkeleton />
      <OrderSkeleton />
      <OrderSkeleton />
    </div>
  );
}

export default OrdersSkeleton;